import { ITooltipProps, tooltipClasses } from '@private/components';
import styled, { css } from 'styled-components';

import Tooltip from 'components/Tooltip';
import { ThemedElement } from 'utils/types';

export const StyledTooltip = styled(Tooltip)<
  ThemedElement<
    ITooltipProps & {
      $maxWarningWidth?: number;
    }
  >
>`
  max-width: max-content;

  ${tooltipClasses.message} {
    word-break: break-word;
    text-align: center;
    white-space: pre-wrap;

    ${({ $maxWarningWidth }) =>
      $maxWarningWidth &&
      css`
        max-width: ${$maxWarningWidth}px;
      `};
  }
`;
